// ==============================|| OVERRIDES - FORM LABEL ||============================== //

export default function FormLabel(theme) {
	return {
		MuiFormLabel: {
			styleOverrides: {
				root: {
					WebkitTextFillColor: theme.palette.primary[800],
				},
			}
		}
	}
}